import { useState } from "react";
import { Link } from "react-router-dom";
import { CreditCard, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, Spinner, TierBadge } from "@/components/Common";
import { useAuth } from "@/context/AuthContext";
import { humanize } from "@/lib/api";
import { nextPlan, openPortal, startCheckout } from "@/lib/billing";

export const BillingCard = () => {
  const { billing, tier } = useAuth();
  const [busy, setBusy] = useState("");
  const next = billing?.trial_active ? "elite" : nextPlan(tier);
  const paid = tier !== "free" && !billing?.trial_active;
  const run = async (k, fn) => { setBusy(k); if (!(await fn())) setBusy(""); };
  const ends = billing?.trial_ends_at && new Date(billing.trial_ends_at).toLocaleDateString();
  const renews = billing?.current_period_end && new Date(billing.current_period_end).toLocaleDateString();
  return (
    <Card id="billing" data-testid="billing-card">
      <div className="mb-4 flex items-center gap-2"><CreditCard className="h-4 w-4 text-[#D4AF37]" /><h3 className="font-display text-lg text-zinc-100">Plan & billing</h3></div>
      {!billing ? <Spinner className="text-[#D4AF37]" /> : (
        <>
          <div className="flex items-center gap-2 text-sm text-zinc-300" data-testid="billing-current-plan">Current plan: <TierBadge tier={tier} /></div>
          {billing.trial_active && <p className="mt-2 text-xs text-zinc-500" data-testid="billing-trial-note">Elite trial{ends && ` ends ${ends}`}. Subscribe to keep Elite.</p>}
          {paid && renews && <p className="mt-2 text-xs text-zinc-500" data-testid="billing-renews">{billing.cancel_at_period_end ? "Ends" : "Renews"} {renews}</p>}
          <div className="mt-4 flex flex-col gap-2">
            {next && <Button onClick={() => run("up", () => startCheckout(next, "/profile"))} disabled={!!busy} data-testid="profile-upgrade-button">{busy === "up" ? <Spinner /> : <Crown className="h-4 w-4" />}{billing.trial_active ? "Subscribe to Elite" : `Upgrade to ${humanize(next)}`}</Button>}
            {paid && <Button variant="outline" onClick={() => run("portal", () => openPortal("/profile"))} disabled={!!busy} data-testid="profile-manage-billing-button">{busy === "portal" ? <Spinner /> : "Manage or cancel subscription"}</Button>}
            <Link to="/upgrade" className="text-center text-xs text-zinc-500 hover:text-[#F3C649]" data-testid="profile-compare-plans-link">Compare plans</Link>
          </div>
          <p className="mt-3 text-[11px] text-zinc-600">One subscription, shared with the RPOPRO mobile app. Payments and cancellations are handled securely by Stripe.</p>
        </>
      )}
    </Card>
  );
};
